import { createSelector } from '@reduxjs/toolkit';
import * as queryString from 'query-string';

import { Session as BaseSession } from '../reducers/select-account-reducer';
import { LoginHint, LoginHintType } from '../utilities/hooks/login-hint';
import { URLParameters } from '../types';
import { RootState } from '../stores/redux.store';

export interface Session extends BaseSession {
  current: boolean;
  hint?: LoginHintType.EmailAddress | LoginHintType.NotEmailAddress;
  suggested: boolean;
}

export const sessionsSelector = createSelector(
  [
    (state: RootState) => state.selectAccount.sessions,
    (_state: RootState, search: string) => search,
    (_state: RootState, _search: string, loginHint?: LoginHint) => loginHint,
  ],
  (sessions, search, loginHint): Session[] => {
    if (!sessions) {
      return [];
    }

    const { suggested } = queryString.parse(search) as URLParameters;

    const combined: Session[] = sessions.associated.map(session => {
      return {
        ...session,
        current: false,
        suggested: false,
      };
    });
    combined.unshift({
      ...sessions.current,
      current: true,
      suggested: false,
    });
    return combined.reduce<Session[]>((sorted, session) => {
      if (loginHint && loginHint.value === session.email) {
        switch (loginHint.type) {
          case LoginHintType.EmailAddress:
          case LoginHintType.NotEmailAddress:
            sorted.unshift({
              ...session,
              hint: loginHint.type,
            });
            break;
          default:
            sorted.push(session);
        }
      } else {
        sorted.push({
          ...session,
          suggested: session.email === suggested,
        });
      }
      return sorted;
    }, []);
  }
);

export default sessionsSelector;
